import { Theme } from "../../../components/constants";

export default {
    mainContainer: {
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100%', 
        width: '70%', 
        alignSelf: 'center',
        gap: '60px',
    },
    leftInnerContainer: {
        flex: 1, 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '50px', 
        padding: '35px'
    },
    rightInnerContainer: {
        flex: 1, 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        padding: '35px', 
        gap: '20px',
    },
    inputContainer: {
        width: '100%', 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '20px'
    },
    errorMessage: {
        fontSize: "16px", 
        lineHeight: "20px", 
        color: Theme.ERROR_TEXT
    },
    submitButton: {
        padding: '10px 20px', 
        alignSelf: 'end'
    },
    validationColumn: {
        display: 'flex', 
        gap: "15px", 
        alignItems: 'center'
    },
    checkMark: {
        margin: '6px 0.5px'
    },
    validationText: { 
        fontWeight: "400", 
        fontSize: "16px", 
        lineHeight: " 19px"
    },
}